import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';

@Directive({
  selector: '[inlineSVG]',
  standalone: true,
})
export class InlineSvgDirective implements OnChanges {
  @Input() inlineSVG!: string;

  private el = inject(ElementRef<HTMLElement>);

  // 1. Simple in-memory cache
  private static cache = new Map<string, string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.inlineSVG) return;

    if (changes['inlineSVG']?.currentValue === changes['inlineSVG']?.previousValue) {
      return;
    }

    this.loadSvg();
  }

  private async loadSvg() {
    try {
      const url = this.inlineSVG;

      // 2. Check cache first
      if (InlineSvgDirective.cache.has(url)) {
        this.render(InlineSvgDirective.cache.get(url)!);
        return;
      }

      const res = await fetch(url);
      const svg = await res.text();

      // 3. Basic validation
      if (!svg.includes('<svg')) {
        console.warn('Invalid SVG:', url);
        return;
      }

      // store in cache
      InlineSvgDirective.cache.set(url, svg);

      this.render(svg);
    } catch (err) {
      console.error('SVG load failed:', err);
    }
  }

  private render(svg: string) {
    const host = this.el.nativeElement;

    // 4. Preserve host classes on SVG
    const parser = new DOMParser();
    const doc = parser.parseFromString(svg, 'image/svg+xml');
    const svgEl = doc.querySelector('svg');

    if (svgEl) {
      svgEl.setAttribute('class', host.className);
      host.innerHTML = svgEl.outerHTML;
    } else {
      host.innerHTML = svg;
    }
  }
}
